/**
 * 费用模块
 */

import request from '../../request'

export default {
  /**
   * 获取业务日志
   * @param {*} data {bizType, linkId}  bizType: EXPENSE
   * @param {*} options
   * @returns
   */
  fetchLogList: (bizType, linkId, data, options = {}) => {
    return request(
      {
        url: '/biz/log/list',
        method: 'get',
        desc: '获取业务日志'
      },
      {
        ...data,
        bizType,
        linkId
      },
      options
    )
  }

}
